"use client";

import { c as _c } from "react/compiler-runtime";
import { CircleAlert } from "lucide-react";
import { useErrorLogs } from "@/src/lib/data-fetchers/error-log-fetchers";
import { getActionableInstruction } from "@/src/models/error-log";
interface SyncIncompleteActionsProps {
  taskId: string;
}
export function SyncIncompleteActions(t0) {
  const $ = _c(13);
  const {
    taskId
  } = t0;
  const {
    errorLogs
  } = useErrorLogs(taskId);
  if (errorLogs.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== errorLogs) {
    t1 = new Set(errorLogs.map(_temp));
    $[0] = errorLogs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = [...t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const uniqueInstructions = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CircleAlert className="h-4 w-4 text-destructive" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = uniqueInstructions.length === 1 ? "step requires" : "steps require";
  let t5;
  if ($[5] !== t4 || $[6] !== uniqueInstructions.length) {
    t5 = <div className="flex items-center gap-2 mb-3">{t3}<h3 className="font-semibold text-destructive">Sync Incomplete — {uniqueInstructions.length}{" "}{t4} manual attention</h3></div>;
    $[5] = t4;
    $[6] = uniqueInstructions.length;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== uniqueInstructions) {
    t6 = <ul className="list-disc pl-5 space-y-1.5 text-sm text-foreground">{uniqueInstructions.map(_temp2)}</ul>;
    $[8] = uniqueInstructions;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp2(instruction) {
  return <li key={instruction}>{instruction}</li>;
}
function _temp(log) {
  return getActionableInstruction(log);
}